module.exports = __webpack_public_path__ + "static/media/shield-check.9dace97b.svg";